var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyPaste24 = function SvgCopyPaste24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8a5 5 0 0 1 5-5h4a5.001 5.001 0 0 1 4.916 4.084A5.002 5.002 0 0 1 21 12v4a5 5 0 0 1-5 5h-4a5.002 5.002 0 0 1-4.916-4.084A5.001 5.001 0 0 1 3 12V8Zm4 6.83V12a5 5 0 0 1 5-5h2.83A3.001 3.001 0 0 0 12 5H8a3 3 0 0 0-3 3v4c0 1.306.835 2.418 2 2.83ZM9 12a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4Z"
  })));
};
export default SvgCopyPaste24;